__turbopack_context__.v({
  "banner": "styles-module-scss-module__orsP7a__banner",
  "banner__big": "styles-module-scss-module__orsP7a__banner__big",
  "banner__min": "styles-module-scss-module__orsP7a__banner__min",
});
